import React from "react";
import { CheckCircle } from "lucide-react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Utils from "../../utils";
import { decryptData } from "../../utils/crypto";
import { createContactUs } from "../../services/Front/FrontService";
import { useState } from "react";

const FrontFooter = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validateForm = (data) => {
    const errors = {};

    if (!data.email.trim()) {
      errors.email = "Email is required";
    } else {
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailPattern.test(data.email)) {
        errors.email = "Please enter a valid email";
      }
    }

    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const validationErrors = validateForm(formData);

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setIsLoading(true);

    let data = {
      name: "Guest",
      email: formData?.email,
      subject: "early access",
      message: "join early access",
    };

    createContactUs(data)
      .then((response) => {
        const decrypted = decryptData(response.data.data);
        toast.success(decrypted.message);

        setFormData({
          name: "",
          email: "",
          subject: "",
          message: "",
        });
      })
      .catch((error) => {
        toast.error(Utils.getErrorMessage(error));
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  return (
    <footer className="w-full px-4 sm:px-6 py-6 bg-[#020817]">
      <div className="w-full max-w-[1600px] mx-auto bg-space-dark rounded-[2rem] text-white relative overflow-hidden shadow-2xl shadow-voyage-cyan/10">

        {/* Background pattern */}
        <div className="absolute inset-0 opacity-20 pointer-events-none">
          <svg
            className="w-full h-full"
            viewBox="0 0 1000 300"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            preserveAspectRatio="none"
          >
            <path
              d="M100,220 Q300,80 500,170 T900,120"
              stroke="#D4AF37"
              strokeWidth="2"
              strokeDasharray="8 8"
              opacity="0.5"
            />
            <circle cx="100" cy="220" r="4" fill="#D4AF37" />
            <circle cx="350" cy="100" r="4" fill="#D4AF37" />
            <circle cx="700" cy="180" r="4" fill="#D4AF37" />
          </svg>
        </div>

        <div className="relative z-10 px-6 sm:px-10 lg:px-16 py-10 lg:py-12">

          {/* HEADLINE */}
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-center mb-4 tracking-tight">
            Be among the first to explore smarter travel rewards
          </h2>

          {/* SUBTEXT */}
          <p className="text-sm sm:text-base text-center text-white/70 font-medium max-w-2xl mx-auto mb-8">
            Join the early access list and get notified when we launch new tools
            to help you compare and optimize your travel reward points.
          </p>

          {/* EMAIL FORM */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center max-w-2xl mx-auto mb-2">
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email address"
              className="w-full sm:flex-1 px-5 py-4 rounded-2xl text-slate-900 font-semibold outline-none focus:ring-4 focus:ring-voyage-cyan/40 transition-all"
            />

            <button
              onClick={handleSubmit}
              disabled={isLoading}
              className="w-full sm:w-auto bg-voyage-cyan text-space-dark px-8 py-4 rounded-2xl font-black hover:bg-white hover:scale-105 transition-all duration-300"
            >
              {isLoading ? "contact us..." : "Contact Us"}
            </button>
          </div>

          {/* ERROR MESSAGE */}
          {errors.email && (
            <p className="text-red-400 text-sm text-center mt-2">
              {errors.email}
            </p>
          )}

          {/* TRUST BADGES */}
          <div className="flex flex-wrap justify-center gap-6 text-[11px] font-bold uppercase tracking-wider text-voyage-cyan/80 mt-8 mb-8">
            <span className="flex items-center gap-2">
              <CheckCircle size={14} />
              No Spam
            </span>

          

            <span className="flex items-center gap-2">
              <CheckCircle size={14} />
              Product Updates
            </span>
          </div>

          {/* FOOTER LINKS */}
          <div className="border-t border-white/10 pt-5 flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-white/60">
            <p>
              © {new Date().getFullYear()} Just For Points. A travel rewards
              comparison platform.
            </p>

            <div className="flex gap-5">
              <Link to="/privacy-policy" className="hover:text-white transition">
                Privacy Policy
              </Link>

              <Link to="/terms" className="hover:text-white transition">
                Terms of Service
              </Link>

              <Link to="/contact" className="hover:text-white transition">
                Contact
              </Link>

              <Link to="/about" className="hover:text-white transition">
                About
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FrontFooter;